'use client';

import { PLANS } from '@/entities/plan';
import { UserProfile } from '@/entities/user-profile';
import { Button, Separator, Text } from '@/shared/ui/core';
import { Sheet, SheetContent, SheetTrigger, SheetClose } from '@/shared/ui/core/sheet';
import { LandingNavigation } from '@/shared/ui/kit/landing-navigation';
import { ListIcon, XIcon, UserIcon } from '@phosphor-icons/react/dist/ssr';
import { Root as VisuallyHidden } from '@radix-ui/react-visually-hidden';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { useState } from 'react';
import styles from './landing-mobile-menu-sheet.module.scss';


type ComponentProps = {
    profile: UserProfile | null;
}

export function LandingMobileMenuSheet ({ profile }: ComponentProps) {
    const { first_name = '', last_name = '', plan_id } = profile || {};
    const plan                               = PLANS.find(plan => plan.id === plan_id);
    const [ open, setOpen ]                  = useState(false);

    return (
        <Sheet
            open={ open }
            onOpenChange={ setOpen }
            className={ styles.root }
        >
            <SheetTrigger
                className={ styles.trigger }
                asChild
            >
                <Button
                    aria-label="Open menu"
                    variant="naked"
                >
                    <ListIcon size={ 20 }/>
                </Button>
            </SheetTrigger>

            <SheetContent
                className={ styles.content }
                aria-describedby={ undefined }
            >
                <div className={ styles.header }>
                    <div className={ styles.profile }>
                        <UserIcon size={ 32 }/>

                        <div className={ styles.text }>
                            <Text
                                size="lg"
                                tone="primary"
                                weight="semibold"
                                lineHeight={ 1 }
                            >
                                { `${ first_name } ${ last_name }`.trim() || 'Not logged in' }
                            </Text>

                            <Text
                                tone="primary"
                                weight="medium"
                                lineHeight={ 1 }
                            >
                                { plan?.name || 'No Plan selected' }
                            </Text>
                        </div>
                    </div>

                    <SheetClose>
                        <XIcon size={ 20 }/>
                    </SheetClose>
                </div>

                <Separator className={ styles.separator }/>

                <VisuallyHidden>
                    <DialogPrimitive.Title>
                        Menu
                    </DialogPrimitive.Title>
                </VisuallyHidden>

                <LandingNavigation onClick={ () => setOpen(false) }/>
            </SheetContent>
        </Sheet>
    );
}
